module.exports = __webpack_public_path__ + "img/Cover_HW_24.00fb2f61.jpg";